import script from "./OfficeInCharge.vue?vue&type=script&setup=true&lang=js"
export * from "./OfficeInCharge.vue?vue&type=script&setup=true&lang=js"

import "./OfficeInCharge.vue?vue&type=style&index=0&id=755ffcf3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-755ffcf3"]])

export default __exports__